import { render, staticRenderFns } from "./FrsFeatureAvatar.vue?vue&type=template&id=6c7be561&scoped=true&lang=html&"
import script from "./FrsFeatureAvatar.vue?vue&type=script&lang=js&"
export * from "./FrsFeatureAvatar.vue?vue&type=script&lang=js&"
import style0 from "./FrsFeatureAvatar.vue?vue&type=style&index=0&id=6c7be561&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7be561",
  null
  
)

export default component.exports